export const MailIcon: React.FC<any> = ({ className }) => {
   return (
      <div
         className={className}
         dangerouslySetInnerHTML={{
            __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
        <g clip-path="url(#clip0_1463_2054)">
            <path d="M29.4255 1.5835H8.84212C6.5333 1.58601 4.31976 2.5043 2.68718 4.13689C1.05459 5.76947 0.136304 7.98301 0.133789 10.2918L0.133789 27.7085C0.136304 30.0173 1.05459 32.2309 2.68718 33.8634C4.31976 35.496 6.5333 36.4143 8.84212 36.4168H29.4255C31.7343 36.4143 33.9478 35.496 35.5804 33.8634C37.213 32.2309 38.1313 30.0173 38.1338 27.7085V10.2918C38.1313 7.98301 37.213 5.76947 35.5804 4.13689C33.9478 2.5043 31.7343 1.58601 29.4255 1.5835ZM29.4255 6.3335C30.3857 6.33669 31.3114 6.6922 32.0269 7.33258L21.7352 17.6242C21.0362 18.2919 20.1067 18.6644 19.1401 18.6644C18.1735 18.6644 17.2441 18.2919 16.545 17.6242L6.25337 7.33258C6.96563 6.69509 7.88626 6.33978 8.84212 6.3335H29.4255ZM29.4255 31.6668H8.84212C7.79231 31.6668 6.78549 31.2498 6.04316 30.5075C5.30083 29.7651 4.88379 28.7583 4.88379 27.7085V12.6937L13.1789 20.9888C13.9607 21.771 14.8889 22.3914 15.9105 22.8147C16.9321 23.238 18.0271 23.4559 19.133 23.4559C20.2388 23.4559 21.3339 23.238 22.3555 22.8147C23.3771 22.3914 24.3053 21.771 25.0871 20.9888L33.3838 12.6937V27.7085C33.3838 28.7583 32.9668 29.7651 32.2244 30.5075C31.4821 31.2498 30.4753 31.6668 29.4255 31.6668Z" fill="#7F48B8"/>
        </g>
        <defs>
            <clipPath id="clip0_1463_2054">
            <rect width="38" height="38" fill="white" transform="translate(0.133789)"/>
            </clipPath>
        </defs>
        </svg>
    `,
         }}
      />
   )
}
